import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LogOut } from "lucide-react";
import Nav from "@/components/Nav";

/** Shown after "Sign out" in the candidate portal. */
const SignedOut = () => (
  <div className="min-h-screen bg-[#07070c] text-white font-body">
    <Nav />
    <div className="relative min-h-screen flex items-center justify-center px-6 noise overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-40" />
      <div className="absolute -top-40 right-0 h-[420px] w-[420px] rounded-full blur-[130px] opacity-40 bg-[#4d4479]" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        data-testid="signed-out-card"
        className="relative z-10 w-full max-w-md rounded-2xl border border-[#3d414f] bg-[#0a0a12]/90 backdrop-blur-xl p-8 md:p-10 text-center"
      >
        <span className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-[#16fcfb] text-[#07070c]">
          <LogOut size={20} />
        </span>
        <h1 className="mt-5 font-display font-700 text-3xl text-white">You've been signed out</h1>
        <p className="mt-2 font-body text-sm text-white/60">
          Your session has ended. Sign in again to open your candidate dashboard.
        </p>
        <Link
          to="/login"
          replace
          className="mt-7 inline-flex items-center justify-center rounded-full bg-[#16fcfb] px-7 py-3 text-sm font-bold text-[#07070c] hover:opacity-90"
        >
          Sign in again
        </Link>
      </motion.div>
    </div>
  </div>
);

export default SignedOut;
